import { useCallback } from "react";

import { useLayersTs } from "./useLayersTs";

export const useRefreshLayer = () => {
  const [ts, setTs] = useLayersTs();

  return useCallback(
    (layerName?: string) => {
      if (!layerName) {
        return;
      }

      setTs({
        ...ts,
        [layerName]: Date.now(),
      });
    },
    [ts, setTs],
  );
};
